import {useQuoteField} from 'Quoting/components/hooks/useHandleQuoteFieldChange';
import {FormRowGrid, GridRowProps} from 'Quoting/components/shared/GridRow';
import {QuoteFormControlElement} from 'Quoting/components/shared/QuoteFormControlElement';
import {QuoteFormElement} from 'Quoting/components/shared/QuoteFormElement';
import React from 'react';
import {useSelector} from 'react-redux';
import {ReducerState} from 'rootReducer';
import {getOptionFromValue, getOptionFromValueTimePeriod} from '../../PlanTemplates/ACC/benefitDefaults';
import {formatCurrencyValue} from './ACCBenefits';
import {accidentInjuriesPath} from './PropertyPaths/accidentInjuriesPath';

export const BrainInjuryDiagnosis = () => {
  const {getQuoteFieldValue} = useQuoteField();
  const {selectedPlan} = useSelector((state: ReducerState) => state.quoteForm);

  const propertyPaths = accidentInjuriesPath(selectedPlan?.planIndex ?? 0, 0);

  const rows: GridRowProps[] = [
    {
      rowProps: {key: 'brain-injury-diagnosis-row-1'},
      items: [
        {
          key: propertyPaths.brainInjuryDiagnosisDetails.incurralPeriod,
          element: (
            <QuoteFormElement
              elementType="Text"
              label="Incurral Period (Days)"
              value={getQuoteFieldValue<number>(propertyPaths.brainInjuryDiagnosisDetails.incurralPeriod)}
              disabled
              required
              id={propertyPaths.brainInjuryDiagnosisDetails.incurralPeriod}
            />
          ),
          props: {xs: 12, sm: 6, md: 6},
        },
        {
          key: propertyPaths.brainInjuryDiagnosisDetails.customizeBenefitAmount,
          hidden: true,
          element: (
            <QuoteFormControlElement
              controlType="checkbox"
              label="Customize Benefit Amount"
              checked={getQuoteFieldValue<boolean>(propertyPaths.brainInjuryDiagnosisDetails.customizeBenefitAmount)}
              disabled
              id={propertyPaths.brainInjuryDiagnosisDetails.customizeBenefitAmount}
            />
          ),
          props: {xs: 12, sm: 6, md: 6},
        },
      ],
    },
    {
      rowProps: {key: 'brain-injury-diagnosis-row-2'},
      items: [
        {
          key: propertyPaths.brainInjuryDiagnosisDetails.benefitAmount,
          element: (
            <QuoteFormElement
              elementType="Text"
              label="Benefit Amount"
              value={formatCurrencyValue(
                getQuoteFieldValue<number>(propertyPaths.brainInjuryDiagnosisDetails.benefitAmount)
              )}
              disabled
              required
              adornment="money"
              id={propertyPaths.brainInjuryDiagnosisDetails.benefitAmount}
            />
          ),
          props: {xs: 12, sm: 6, md: 6},
        },
        {
          key: propertyPaths.brainInjuryDiagnosisDetails.maxBenefitNumber,
          element: (
            <QuoteFormElement
              elementType="Select"
              label="Number of Times Benefit is Payable per Time Period"
              value={getQuoteFieldValue<number>(propertyPaths.brainInjuryDiagnosisDetails.maxBenefitNumber)}
              disabled
              options={getOptionFromValue(
                getQuoteFieldValue<string>(propertyPaths.brainInjuryDiagnosisDetails.maxBenefitNumber) ?? ''
              )}
              required
              id={propertyPaths.brainInjuryDiagnosisDetails.maxBenefitNumber}
            />
          ),
          props: {xs: 12, sm: 6, md: 6},
        },
      ],
    },
    {
      rowProps: {key: 'brain-injury-diagnosis-row-3'},
      items: [
        {
          key: propertyPaths.brainInjuryDiagnosisDetails.timePeriodCd,
          element: (
            <QuoteFormElement
              elementType="Select"
              label="Time Period"
              value={getQuoteFieldValue<string>(propertyPaths.brainInjuryDiagnosisDetails.timePeriodCd)}
              disabled
              options={getOptionFromValueTimePeriod(
                getQuoteFieldValue<string>(propertyPaths.brainInjuryDiagnosisDetails.timePeriodCd) ?? ''
              )}
              required
              id={propertyPaths.brainInjuryDiagnosisDetails.timePeriodCd}
            />
          ),
          props: {xs: 12, sm: 6, md: 6},
        },
      ],
    },
  ];

  return <FormRowGrid rows={rows} />;
};
